import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

const AssistantPageClientContext = createContext({
  pageClientLabel: '',
  setPageClientLabel: () => {},
});

export function AssistantPageClientProvider({ children }) {
  const [pageClientLabel, setPageClientLabelState] = useState('');

  const setPageClientLabel = useCallback((label) => {
    setPageClientLabelState(typeof label === 'string' ? label.trim() : '');
  }, []);

  const value = useMemo(
    () => ({ pageClientLabel, setPageClientLabel }),
    [pageClientLabel, setPageClientLabel],
  );

  return (
    <AssistantPageClientContext.Provider value={value}>
      {children}
    </AssistantPageClientContext.Provider>
  );
}

export function useAssistantPageClient() {
  return useContext(AssistantPageClientContext);
}

/**
 * Publie le libellé client de la page courante pour le widget assistant.
 * Nettoie à '' au unmount.
 */
export function useSetAssistantPageClient(label) {
  const { setPageClientLabel } = useAssistantPageClient();

  useEffect(() => {
    setPageClientLabel(label || '');
    return () => setPageClientLabel('');
  }, [label, setPageClientLabel]);
}
